/**
 * @generated SignedSource<<801ff37bb3996193b55e96efcee6f0e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PersonUpdateInput = {
  contract?: PersonUpdateInputContract | null | undefined;
  person?: PersonUpdateInputPerson | null | undefined;
};
export type PersonUpdateInputContract = {
  contract_type?: string | null | undefined;
  cost?: number | null | undefined;
  employment_type: string;
  end_date?: string | null | undefined;
  job_title?: string | null | undefined;
  minutes_per_day: number;
  role_id: number;
  rostered_days: ReadonlyArray<number | null | undefined>;
  start_date?: string | null | undefined;
};
export type PersonUpdateInputPerson = {
  competencies?: ReadonlyArray<PersonCompetencies> | null | undefined;
  custom_values?: PersonInputCustomValues | null | undefined;
  email?: string | null | undefined;
  first_name: string;
  holidays_group_id?: number | null | undefined;
  last_name: string;
  links?: ReadonlyArray<PersonInputLink> | null | undefined;
  manager_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  person_id: number;
  references: any;
  tags: ReadonlyArray<string | null | undefined>;
  team_id?: number | null | undefined;
  team_name?: string | null | undefined;
};
export type PersonCompetencies = {
  level?: number | null | undefined;
  skill: PersonSkill;
};
export type PersonSkill = {
  name: string;
};
export type PersonInputCustomValues = {
  checkbox?: ReadonlyArray<PersonInputCustomValuesCheckbox | null | undefined> | null | undefined;
  date?: ReadonlyArray<PersonInputCustomValuesDate | null | undefined> | null | undefined;
  select?: ReadonlyArray<PersonInputCustomValuesSelect | null | undefined> | null | undefined;
  text?: ReadonlyArray<PersonInputCustomValuesText | null | undefined> | null | undefined;
};
export type PersonInputCustomValuesCheckbox = {
  typeId: number;
  value: boolean;
};
export type PersonInputCustomValuesDate = {
  typeId: number;
  value?: string | null | undefined;
};
export type PersonInputCustomValuesSelect = {
  optionId: number;
  typeId: number;
};
export type PersonInputCustomValuesText = {
  typeId: number;
  value: string;
};
export type PersonInputLink = {
  href: string;
  id?: number | null | undefined;
  name: string;
  show_in_planner: boolean;
};
export type PersonUpdateMutation$variables = {
  input: PersonUpdateInput;
  plannerStartDate?: any | null | undefined;
};
export type PersonUpdateMutation$data = {
  readonly action_person_update: {
    readonly account: {
      readonly competencies: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly id: number;
      readonly invitations: ReadonlyArray<{
        readonly email: string;
        readonly id: number;
      }>;
      readonly people: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly people_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly people_tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly skills: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly teams: ReadonlyArray<{
        readonly id: number;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly person: {
      readonly account_id: number;
      readonly active: boolean;
      readonly competencies: ReadonlyArray<{
        readonly id: number;
        readonly level: number | null | undefined;
        readonly person: {
          readonly first_name: string;
          readonly id: number;
          readonly last_name: string;
        };
        readonly person_id: number;
        readonly skill: {
          readonly id: number;
          readonly name: string;
        };
      }>;
      readonly contracts: ReadonlyArray<{
        readonly cost: number | null | undefined;
        readonly employment_type: string;
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly job_title: string | null | undefined;
        readonly minutes_per_day: number | null | undefined;
        readonly padded_cost: number | null | undefined;
        readonly person: {
          readonly id: number;
        };
        readonly role: {
          readonly id: number;
          readonly name: string;
        };
        readonly role_id: number;
        readonly rostered_days: ReadonlyArray<number> | null | undefined;
        readonly start_date: string | null | undefined;
      }>;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly email: string | null | undefined;
      readonly first_name: string;
      readonly holidays_group: {
        readonly id: number;
      } | null | undefined;
      readonly id: number;
      readonly is_placeholder: boolean;
      readonly last_name: string;
      readonly links: ReadonlyArray<{
        readonly href: string;
        readonly id: number;
        readonly name: string;
        readonly show_in_planner: boolean;
      }>;
      readonly managers: ReadonlyArray<{
        readonly id: number;
        readonly person: {
          readonly id: number;
        };
        readonly user: {
          readonly first_name: string | null | undefined;
          readonly id: number;
          readonly last_name: string | null | undefined;
        };
        readonly user_id: number;
      }>;
      readonly references: any;
      readonly tags: any;
      readonly team: {
        readonly id: number;
        readonly name: string;
      } | null | undefined;
      readonly team_id: number | null | undefined;
      readonly time_offs: ReadonlyArray<{
        readonly end_date: string | null | undefined;
        readonly ext_time_off_links: ReadonlyArray<{
          readonly active: boolean;
          readonly ext_time_off_id: number;
          readonly external: {
            readonly __typename: "ext_time_off";
            readonly id: number;
            readonly integration_id: number;
          } | null | undefined;
          readonly external_id: number;
          readonly time_off_id: number;
        }>;
        readonly holiday: {
          readonly holidays_group: {
            readonly id: number;
            readonly name: string;
          };
          readonly id: number;
          readonly name: string;
          readonly type: string;
        } | null | undefined;
        readonly id: number;
        readonly leave_type: string;
        readonly note: string | null | undefined;
        readonly person_id: number;
        readonly start_date: string | null | undefined;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type PersonUpdateMutation = {
  response: PersonUpdateMutation$data;
  variables: PersonUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plannerStartDate"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "first_name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last_name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": "start_date",
  "args": null,
  "kind": "ScalarField",
  "name": "start_date_runn",
  "storageKey": null
},
v7 = {
  "alias": "end_date",
  "args": null,
  "kind": "ScalarField",
  "name": "end_date_runn",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  (v1/*: any*/),
  (v8/*: any*/)
],
v10 = [
  (v1/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "people",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "person_id",
  "storageKey": null
},
v13 = {
  "_eq": true
},
v14 = [
  (v1/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v16 = [
  (v1/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "model",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "archived",
    "storageKey": null
  }
],
v17 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PersonUpdateOutput",
    "kind": "LinkedField",
    "name": "action_person_update",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "people",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "is_placeholder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "team_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tags",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "references",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "account_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "contracts",
            "kind": "LinkedField",
            "name": "contracts",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minutes_per_day",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employment_type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rostered_days",
                "storageKey": null
              },
              {
                "alias": "cost",
                "args": null,
                "kind": "ScalarField",
                "name": "cost_private",
                "storageKey": null
              },
              {
                "alias": "padded_cost",
                "args": null,
                "kind": "ScalarField",
                "name": "cost_padded_private",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "job_title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "roles",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "teams",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "people_links",
            "kind": "LinkedField",
            "name": "links",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "href",
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "show_in_planner",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "_gte",
                        "variableName": "plannerStartDate"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "end_date_iso"
                  }
                ],
                "kind": "ObjectValue",
                "name": "where"
              }
            ],
            "concreteType": "time_offs",
            "kind": "LinkedField",
            "name": "time_offs",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "leave_type",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "note",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "holidays",
                "kind": "LinkedField",
                "name": "holiday",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "holidays_groups",
                    "kind": "LinkedField",
                    "name": "holidays_group",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "active": (v13/*: any*/)
                    }
                  }
                ],
                "concreteType": "ext_time_off_link",
                "kind": "LinkedField",
                "name": "ext_time_off_links",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "time_off_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_time_off_id",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": "external_id",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_time_off_id",
                    "storageKey": null
                  },
                  {
                    "alias": "external",
                    "args": null,
                    "concreteType": "ext_time_off",
                    "kind": "LinkedField",
                    "name": "ext_time_off",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integration_id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ext_time_off_links(where:{\"active\":{\"_eq\":true}})"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "competencies",
            "kind": "LinkedField",
            "name": "competencies",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "level",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "skills",
                "kind": "LinkedField",
                "name": "skill",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "people",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "people_managers",
            "kind": "LinkedField",
            "name": "managers",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "user_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "users",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "holidays_groups",
            "kind": "LinkedField",
            "name": "holidays_group",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_text_values",
            "kind": "LinkedField",
            "name": "custom_text_values",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": "typeId",
                "args": null,
                "kind": "ScalarField",
                "name": "custom_text_type_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_date_values",
            "kind": "LinkedField",
            "name": "custom_date_values",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": "typeId",
                "args": null,
                "kind": "ScalarField",
                "name": "custom_date_type_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_select_values",
            "kind": "LinkedField",
            "name": "custom_select_values",
            "plural": true,
            "selections": [
              {
                "alias": "optionId",
                "args": null,
                "kind": "ScalarField",
                "name": "custom_select_option_id",
                "storageKey": null
              },
              {
                "alias": "typeId",
                "args": null,
                "kind": "ScalarField",
                "name": "custom_select_type_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_checkbox_values",
            "kind": "LinkedField",
            "name": "custom_checkbox_values",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": "typeId",
                "args": null,
                "kind": "ScalarField",
                "name": "custom_checkbox_type_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "teams",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "people",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "active": (v13/*: any*/),
                  "is_placeholder": {
                    "_eq": false
                  }
                }
              }
            ],
            "concreteType": "people_aggregate",
            "kind": "LinkedField",
            "name": "people_aggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "people_aggregate_fields",
                "kind": "LinkedField",
                "name": "aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "people_aggregate(where:{\"active\":{\"_eq\":true},\"is_placeholder\":{\"_eq\":false}})"
          },
          {
            "alias": "people_tags",
            "args": [
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "model": {
                    "_eq": "person"
                  }
                }
              }
            ],
            "concreteType": "tags",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": (v16/*: any*/),
            "storageKey": "tags(where:{\"model\":{\"_eq\":\"person\"}})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "tags",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "competencies",
            "kind": "LinkedField",
            "name": "competencies",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "skills",
            "kind": "LinkedField",
            "name": "skills",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "invitations",
            "kind": "LinkedField",
            "name": "invitations",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonUpdateMutation",
    "selections": (v17/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PersonUpdateMutation",
    "selections": (v17/*: any*/)
  },
  "params": {
    "cacheID": "bc963adbe8b2b85870ffcabf916af582",
    "id": null,
    "metadata": {},
    "name": "PersonUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PersonUpdateMutation(\n  $input: PersonUpdateInput!\n  $plannerStartDate: date\n) {\n  action_person_update(input: $input) {\n    person {\n      id\n      active\n      first_name\n      last_name\n      email\n      is_placeholder\n      team_id\n      tags\n      references\n      account_id\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        employment_type\n        rostered_days\n        cost: cost_private\n        padded_cost: cost_padded_private\n        job_title\n        role_id\n        role {\n          id\n          name\n        }\n        person {\n          id\n        }\n      }\n      team {\n        id\n        name\n      }\n      links {\n        id\n        href\n        name\n        show_in_planner\n      }\n      time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        leave_type\n        person_id\n        note\n        holiday {\n          id\n          type\n          name\n          holidays_group {\n            id\n            name\n          }\n        }\n        ext_time_off_links(where: {active: {_eq: true}}) {\n          time_off_id\n          ext_time_off_id\n          active\n          external_id: ext_time_off_id\n          external: ext_time_off {\n            __typename\n            id\n            integration_id\n          }\n        }\n      }\n      competencies {\n        id\n        level\n        person_id\n        skill {\n          id\n          name\n        }\n        person {\n          id\n          first_name\n          last_name\n        }\n      }\n      managers {\n        id\n        user_id\n        user {\n          id\n          first_name\n          last_name\n        }\n        person {\n          id\n        }\n      }\n      holidays_group {\n        id\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n    }\n    account {\n      id\n      teams {\n        id\n        name\n      }\n      people {\n        id\n      }\n      people_aggregate(where: {active: {_eq: true}, is_placeholder: {_eq: false}}) {\n        aggregate {\n          count\n        }\n      }\n      people_tags: tags(where: {model: {_eq: \"person\"}}) {\n        id\n        name\n        model\n        archived\n      }\n      tags {\n        id\n        name\n        model\n        archived\n      }\n      competencies {\n        id\n      }\n      skills {\n        id\n      }\n      invitations {\n        id\n        email\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "073048201197bfe9a474bc55190f9d1d";

export default node;
